import { FACILITY_WORKSPACE_COOKIE } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
export const getTenantFacilityCookie = (tenantId) => {
    return `${FACILITY_WORKSPACE_COOKIE}.${tenantId}`;
};
